import styled, { css } from 'styled-components';
import { darkLava } from '@/app/components/search/styles/colors.ts';

export const LoyaltyBadgeWrapper = styled.div<{ isEmpty: boolean }>`
  margin-bottom: 4px;
  display: inline-block;

  // ensure the Loyalty img container has the dark lava color
  div:has(> img) {
    background-color: ${darkLava};
  }

  ${({ isEmpty }) =>
    isEmpty &&
    css`
      border-radius: 4px;

      div:empty {
        display: none;
      }
    `}
`;
